var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imprint"},[_c('div',{staticClass:"navigation-spacer"}),_c('div',{staticClass:"container page-component"},[_c('h1',[_vm._v(_vm._s(_vm.fields.title))]),_c('prismic-rich-text',{attrs:{"field":_vm.fields.text}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }